<div>
    <h1>Code Translation Upload</h1>
    <p>Select a file below to upload for translation. Provide one or more sample data files and an expected output file
        to be used for validation of the code translation. If you are unable to provide sample data files or an expected
        output file
        due to sensitive data concerns, please check the "I will validate translation" checkbox to skip providing sample
        data files
        and and expected output file.</p>
</div>
@if (fileSizeErrorMessage) {
<p class="uploadStatus uploadStatus--error" role="alert">{{ fileSizeErrorMessage }}</p>
}

@if (uploadSuccessMessage) {
<p class="uploadStatus uploadStatus--success" role="status">{{ uploadSuccessMessage }}</p>
}

@if (uploadErrorMessage) {
<p class="uploadStatus uploadStatus--error" role="alert">{{ uploadErrorMessage }}</p>
}

@if (uploadValidationErrors.length > 0) {
<ul class="uploadValidationErrors" aria-label="Upload validation errors">
    @for (validationError of uploadValidationErrors; track validationError) {
    <li>{{ validationError }}</li>
    }
</ul>
}
<div>
    <h2>1. Translation Name</h2>
    <p>Provide a name that will help you identify this translation.</p>
    <input class="translationNameInput" id="translationName" name="translationName" type="text"
        [(ngModel)]="translationName" [disabled]="isProcessing" />
</div>
<div>
    <h2>2. Input File</h2>
    <app-fileupload #inputFileUpload id="inputFile" name="inputFile" [accept]="inputFileAccept"
        [multiple]="inputFileMultiple" (fileChange)="onInputFileChange($event)"></app-fileupload>
</div>
<div>
    <h2>3. Validation</h2>
    <div class="validationSection">
        <h3><input type="checkbox" id="willValidateTranslation" name="willValidateTranslation"
                [ngModel]="willValidateTranslation" [disabled]="isProcessing"
                (ngModelChange)="onWillValidateTranslationChange($event)" /> I will validate translation
        </h3>
    </div>
    @if (!willValidateTranslation) {
    <div class="validationSection">
        <h3>Sample Data File(s)</h3>
        <app-fileupload #sampleDataFilesUpload id="sampleDataFiles" name="sampleDataFiles"
            [accept]="sampleDataFilesAccept" [multiple]="sampleDataFilesMultiple"
            (fileChange)="onSampleDataFilesChange($event)"></app-fileupload>
    </div>
    <div class="validationSection">
        <h3>Expected Output File</h3>
        <app-fileupload #expectedOutputFileUpload id="expectedOutputFile" name="expectedOutputFile"
            [accept]="expectedOutputFileAccept" [multiple]="expectedOutputFileMultiple"
            (fileChange)="onExpectedOutputFileChange($event)"></app-fileupload>
    </div>
    }
</div>

<div class="uploadActions">
    <button class="primaryBtn uploadActions__button" type="button" [disabled]="!canUpload || isProcessing"
        (click)="onUpload()">
        Upload
    </button>
</div>